import { sendGet } from '../hooks/use-fetch'
import { type NeedsAttentionModel } from '../models/NeedsAttentionModel'

export async function GetNeedsAttention (orgId: string): Promise<NeedsAttentionModel> {
  const { response } = await sendGet(`NeedsAttention/GetAll?orgId=${orgId}`)
  return response
}
